import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
   0% { background-position: -468px 0; }
   100% { background-position: 468px 0; }
`;

const SkeletonBox = styled.div`
   background: linear-gradient(to right, #F0F0F2 8%, #E7E7E9 18%, #F0F0F2 33%);
   background-size: 800px 104px;
   animation: ${shimmer} 1.5s linear infinite;
   border-radius: 6px;
`;

const TableWrapper = styled.div`
   background: #fff;
   border: 1px solid #E7E7E9;
   border-radius: 12px;
   overflow: hidden;
`;

const SkeletonRow = styled.div`
   display: flex;
   align-items: center;
   gap: 16px;
   padding: 16px 20px;
   border-bottom: 1px solid #F0F0F2;
   
   &:last-child {
      border-bottom: none;
   }
`;

const SkeletonCell = styled(SkeletonBox)<{ width: string }>`
   height: 14px;
   width: ${props => props.width};
`;

export default function SkeletonTable(): React.JSX.Element {
   return (
      <TableWrapper>
         {[...Array(5)].map((_, i) => (
            <SkeletonRow key={i}>
               <SkeletonCell width="15%" />
               <SkeletonCell width="20%" />
               <SkeletonCell width="15%" />
               <SkeletonCell width="10%" />
               <SkeletonCell width="15%" />
               <SkeletonCell width="10%" />
               <SkeletonCell width="10%" />
            </SkeletonRow>
         ))}
      </TableWrapper>
   );
}
